/** Longest line name the API accepts (`LineCreate.name`, `maxLength: 160`). */
export const LINE_NAME_MAX_LENGTH = 160;

/**
 * Fit a line name within the API limit, ending in an ellipsis when shortened.
 * Derived names ("Main line · Nf3 · e6 · …") and numbered import names can otherwise
 * exceed the limit, and the save is then refused with a 422.
 */
export function clampLineName(name: string): string {
  const chars = Array.from(name);
  if (chars.length <= LINE_NAME_MAX_LENGTH) return name;
  return `${chars.slice(0, LINE_NAME_MAX_LENGTH - 1).join('').trimEnd()}…`;
}
